<template>
  <header class="section-heading">
    <p class="section-heading__eyebrow">{{ eyebrow }}</p>
    <h2>{{ title }}</h2>
    <p v-if="description" class="section-heading__description">
      {{ description }}
    </p>
  </header>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SectionHeading",
  props: {
    eyebrow: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
  },
});
</script>

<style scoped>
.section-heading {
  max-width: 780px;
}

.section-heading__eyebrow {
  margin: 0 0 10px;
  color: var(--color-muted);
  font-size: 0.82rem;
  font-weight: 700;
  text-transform: uppercase;
}

h2 {
  margin: 0;
  color: var(--color-ink);
  font-size: 2.05rem;
  line-height: 1.15;
}

.section-heading__description {
  margin: 18px 0 0;
  color: var(--color-muted);
  font-size: 1.05rem;
  line-height: 1.7;
}

@media (max-width: 720px) {
  h2 {
    font-size: 1.65rem;
  }
}

@media (max-width: 760px) {
  .section-heading {
    max-width: none;
  }

  .section-heading__eyebrow {
    margin-bottom: 9px;
    font-size: 0.74rem;
  }

  h2 {
    font-size: 1.72rem;
    line-height: 1.12;
  }

  .section-heading__description {
    margin-top: 14px;
    font-size: 1rem;
    line-height: 1.62;
  }
}
</style>
